// import QueryAll from "./queryAll.gql";
import QueryList from "./queryList.gql";
import QuerySimList from "./querySimList.gql";
import MeetingDetail from "./queryDetail.gql";
import QueryTlcInfo from "./queryTlcInfo.gql";
import QueryLvcInfo from "./queryLvcInfo.gql";
import QueryOutUserInfo from "./queryOutUserInfo.gql";
import ReserveMeeting from "./reserveMeeting.gql";
import EditMeeting from "./editMeeting.gql";
import DelayMeeting from "./delayMeeting.gql";
import CancelMeeting from "./cancelMeeting.gql";
import FinishMeeting from "./finishMeeting.gql";
import CheckInMeeting from "./checkInMeeting.gql";
import AttendanceResp from "./attendanceResp.gql";
// import SearchMeetingConflict from "./meetingConflict.gql";
// import searchPeriodicMtRoomConflict from "./periodicMtRoomConflict.gql";
import OutsideCheckInMeeting from "./outsideCheckInMeeting.gql";
import ChangeLvcStatus from "./changeLvcStatus.gql";
import {mutationHdl, queryHdl} from '../graphqlHdr';

export default {
  /*
  queryAll: (vueSelf, variables) => queryHdl.call(vueSelf, QueryAll, {
    ...variables,
    filterCancel: false,
  }),
  */
  // 查询会议列表
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, {
    filterCancel: false,
    ...variables,
  }),

  querySimpleList: (vueSelf, variables) => queryHdl.call(vueSelf, QuerySimList, {
    filterCancel: true,
    ...variables,
  }),

  // selfCursor 查询会议详情
  queryDetail: (vueSelf, variables) => queryHdl.call(vueSelf, MeetingDetail, {
    filterCancel: false,
    ...variables,
  }),

  // queryMeetingConflict: (vueSelf, variables) => queryHdl.call(vueSelf, SearchMeetingConflict, variables),

  // queryPeriodicMtRoomConflict: (vueSelf, variables) => queryHdl.call(vueSelf, searchPeriodicMtRoomConflict, variables),

  queryTlcInfo: (vueSelf, variables) => queryHdl.call(vueSelf, QueryTlcInfo, {
    ...variables
  }),
  queryLvcInfo: (vueSelf, variables) => queryHdl.call(vueSelf, QueryLvcInfo, {
    ...variables
  }),
  queryOutUserInfo: (vueSelf, variables) => queryHdl.call(vueSelf, QueryOutUserInfo, {
    ...variables
  }),
  // 预约会议
  reserveMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, ReserveMeeting, variables),
  // 编辑会议
  editMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, EditMeeting, variables),
  // 延迟会议
  delayMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, DelayMeeting, variables),
  // 取消会议
  cancelMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, CancelMeeting, variables),
  // 会议已结束
  finishMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, FinishMeeting, variables),
  // 签到
  checkInMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, CheckInMeeting, variables),
  // 应答
  attendanceResp: (vueSelf, variables) => mutationHdl.call(vueSelf, AttendanceResp, variables),
  // 外部参会人签到
  outsideCheckInMeeting: (vueSelf, variables) => mutationHdl.call(vueSelf, OutsideCheckInMeeting, variables),
  // 更改直播状态
  changeLvcStatus: (vueSelf, variables) => mutationHdl.call(vueSelf, ChangeLvcStatus, variables),
}
